export const NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED' as const;
export const NETWORK_CONNECTED = 'NETWORK_CONNECTED' as const;

export const networkDisconnected = () => {
  return {
    type: NETWORK_DISCONNECTED,
  };
};

export const networkConnected = () => {
  return {
    type: NETWORK_CONNECTED,
  };
};
